@if (multiline()) {
<textarea
  [zagScrollIntoView]="true"
  class="zag-input zag-input--multiline {{ inputClass() }}"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [id]="id()"
  [name]="name()"
  [required]="required()"
  [rows]="rows()"
  [value]="value()"
  [attr.aria-describedby]="ariaDescribedby() ?? null"
  [attr.aria-required]="required() ? 'true' : null"
  [class.focused]="focused()"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
></textarea>
} @else { @if (type() === 'file') {
<input
  [zagScrollIntoView]="true"
  class="zag-input {{ inputClass() }}"
  [type]="type()"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [id]="id()"
  [name]="name()"
  [autocomplete]="autocomplete()"
  [attr.accept]="accept() ?? null"
  [pattern]="pattern()"
  [required]="required()"
  [attr.aria-describedby]="ariaDescribedby() ?? null"
  [attr.aria-required]="required() ? 'true' : null"
  [class.focused]="focused()"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
/>
} @else {
<input
  [zagScrollIntoView]="true"
  class="zag-input {{ inputClass() }}"
  [type]="type()"
  [(value)]="value"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [id]="id()"
  [name]="name()"
  [autocomplete]="autocomplete()"
  [attr.accept]="accept() ?? null"
  [pattern]="pattern()"
  [required]="required()"
  [attr.aria-describedby]="ariaDescribedby() ?? null"
  [attr.aria-required]="required() ? 'true' : null"
  [class.focused]="focused()"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
/>
} }
